<template>
    <!-- 付费结构模块 -->
    <div class="container" >
        <PageHeader style="margin:10px 0 0 0;"/>
        <div class="content page_main_content">
            <div class="data-panel page_block">
                <div class="data-panel-header">
                    <h2>付费结构</h2>
                    <div class="extra">
                        <a-button @click="exportToExcel('vip_table', `${$service.PROJ_CODE}-付费结构-${display=='day'?date.format('YYYY-MM-DD'):month.format('YYYY-MM')}`)" :title="$t('common.downloadData')"><a-icon type="download"/></a-button>
                        <a-button @click="copy('vip_table')" id="copy-btn" style="margin:0 16px 0 8px;" :title="$t('common.copyData')"><a-icon type="copy"/></a-button>
                        <a-radio-group v-model="display" style="margin:0 16px 0 0;">
                            <a-radio-button value="day">日</a-radio-button>
                            <a-radio-button value="month">月</a-radio-button>
                        </a-radio-group>
                        <a-date-picker v-model="date" :allowClear="false" v-if="display=='day'"/>
                        <a-month-picker v-model="month" :allowClear="false" v-if="display=='month'" placeholder="请选择月份"/>
                    </div>
                </div>
                <div class="data-panel-content" style="padding: 20px">
                    <VipChart :datas="display=='day'?day_datas:month_datas" :conf="chart" :fields="fields" :height="500" style="border-bottom:1px dashed #ddd; margin:50px 0 20px 0; padding:0 0 10px 0"/>
                    <DataTable class="pay_vip_table" :fields="display==='month'?mfields:fields" :datas="display=='day'?day_datas:month_datas" ref="vip_table" :paging="false" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from '@/components/game/pageheader.vue'
import VipChart from '@/components/common/chart/vip_chart.vue'
import DataTable from '@/components/common/datatable.vue'
import {ctrlMixin} from '@/utils/ctrlMixin.js'
import {datatableMixin} from '@/components/common/datatable/datatableMixin.js'

import Vue from 'vue'
import {DatePicker} from 'ant-design-vue';
Vue.use(DatePicker)


import moment from "moment"

const today = moment()
const yesterday = moment(today).subtract(1, 'day')

export default {
    mixins: [ctrlMixin, datatableMixin],
    name:'d90index',
    props: ['parent', 'name'],
    components: {
        PageHeader,
        DataTable,
        VipChart
    },
    mounted() {
        this.getData('day')
        this.getData('month')
    },
    watch: {
        // 付费结构选择月份
        month(newV) {
            if(newV) {
                this.getData('month')
            }
        },
        // 付费结构选择时间
        date(newV) {
            if(newV) {
                this.getData('day')
            }
        }
    },
    data() {
        return {
            api: 'pay_vip',
            display:'day',
            day_datas: [],
            month_datas: [],
            date: yesterday,
            month: yesterday,
            fields: [
                    {id: 'vip_level', title: 'vip等级'},
                    {id: 'vip_name', title: '备注'},
                    {id: 'history_cash_rate', title: '历史总充值占比', suffix:'%'},
                    {id: 'target_cash_rate', title: '统计期充值占比', suffix:'%', class:'today_cash_rate'},
                    {id: 'target_cash', title: '统计期充值贡献', class:'sum_cash'},
                    {id: 'day', title: ''},
                    {id: 'vip_log_cnt', title: '登录人数'},
                    {id: 'log_rate', title: '登录人数占比'},
                    {id: 'nolog_7days_cnt', title: '7日未登录人数'},
                    {id: 'vip_cnt_all', title: '历史人数'},
                    {id: 'liushi_rate', title: '流失率', suffix:'%', desc:'7日未登录人数/历史人数'},
            ],
            mfields: [
                    {id: 'vip_level', title: 'vip等级'},
                    {id: 'vip_name', title: '备注'},
                    {id: 'history_cash_rate', title: '历史总充值占比', suffix:'%'},
                    {id: 'target_cash_rate', title: '统计期充值占比', suffix:'%', class:'today_cash_rate'},
                    {id: 'target_cash', title: '统计期充值贡献', class:'sum_cash'},
                    {id: 'day', title: ''},
                    {id: 'vip_log_cnt', title: '登录人数'},
                    {id: 'log_rate', title: '登录人数占比'},
                    {id: 'nolog_7days_cnt', title: '90日未登录人数'},
                    {id: 'vip_cnt_all', title: '历史人数'},
                    {id: 'liushi_rate', title: '流失率', suffix:'%', desc:'3月未登录人数/截至当月月底的vip历史人数'},
            ],
            chart: {
                x: {id: 'vip_level', title: 'vip等级'},
                y: [
                    {id: 'target_cash', title: '充值金额', color:'#1890ff', ratio:'target_cash_rate'}, 
                    {id: 'target_log_cnt', title: '登录人数', color:'#92cea3', ratio:'target_log_rate'},
                ]
            },
        }
    },
    methods: {
        getData(type) {
            this.loading = true
            let dt=type=='day'?this.date.format('YYYY-MM-DD'):this.month.format('YYYYMM')
            this.$service.query(this.queryId, {dt, type}).then((data)=>{
                if(type=='day') {
                    this.day_datas = data
                }
                if(type=='month') {
                    this.month_datas = data
                }
            }).finally((data)=> {
                this.loading = false
            })
        }
    }
}
</script>


<style lang="less">
.pay_vip_table {
    .yesterday_tag {
        color:#1890ff;
    }
    .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td > div {
        padding: 6px 10px;
    }
    .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
        &.today_cash_rate_th, &.sum_cash_th {
            background:#e8f4ff;
            border-top:1px solid #8bc7ff;
        }
        &.today_cash_rate_th {
            border-left:1px solid #8bc7ff;
        }
        &.sum_cash_th {
            border-right:1px solid #8bc7ff;
        }
    }
    .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td {
        &.today_cash_rate_td {
            border-left:1px solid #8bc7ff;
        }
        &.sum_cash_td {
            border-right:1px solid #8bc7ff;
        }
        &.today_cash_rate_td:nth-last-child(1), &.sum_cash_td:nth-last-child(1) {
            border-bottom:1px solid #8bc7ff;
        }
    }
    tr.ant-table-row:nth-last-child(1){
        td.today_cash_rate_td, td.sum_cash_td{
            border-bottom:1px solid #8bc7ff;
        }
    }
}
</style>